import { render, staticRenderFns } from "./addRuKuPlan.vue?vue&type=template&id=23b61ea6&scoped=true&"
import script from "./addRuKuPlan.vue?vue&type=script&lang=js&"
export * from "./addRuKuPlan.vue?vue&type=script&lang=js&"
import style0 from "./addRuKuPlan.vue?vue&type=style&index=0&id=23b61ea6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b61ea6",
  null
  
)

export default component.exports